

import resident from '../assets/resident.jpg'
import guest from '../assets/guest.jpg'
export const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
export const GUEST_REGEX = /guest\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i
export const STATE = {
  PASS: "PASS",
  FAIL: "FAIL",
  PENDING: "PENDING",
  WAITING: "WAITING"
}
export const PAGES = {
  HOME: {
    pattern: /^\/$/,
    title: "Home"
  },
  RESIDENT: {
    pattern: /^\/resident$/,
    title: "Resident"
  },
  GUEST: {
    pattern: /^\/guest(\/[a-zA-Z0-9-]*)*$/,
    title: "Register Pass"
  },
  GUEST_ID: {
    pattern: /^\/guest\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/,
    title: "Register Pass"
  },
  GATE: {
    pattern: /^\/scan$/,
    title: "Gate"
  }
}
export const PATHS = {
  '/': 'HOME',
  '/resident': 'RESIDENT',
  '/guest': 'GUEST',
  '/gate': 'GATE'
}
export const PASS_VIEWS = {
  ACTIVE: "active",
  HISTORY: "history"
}
export const PASS_STATUS = {
  CREATED: "CREATED",
  REGISTERED: "REGISTERED",
  REDEEMED: "REDEEMED"
}
export const PASS_STATUS_STYLE = {
  CREATED: 'dark',
  REGISTERED: 'main',
  REDEEMED: 'light'
}
export const PAGE_CARDS = {
  RESIDENT: {
    title: "Residents",
    image: resident,
    content: "Instead of waiting for a call from the gate, send passes directly to your guests.",
    action: [{ title: "Create a pass", link: "/resident" }]
  },
  GUEST: {
    title: "Guests",
    image: guest,
    content: "Don't get towed, enter a few details about your car to let the property management know you're good people.",
    action: [{ title: "Register a pass", link: "/guest" }, { title: "Scan a pass", link: "/scan" }]
  }
}


// WEBPACK FOOTER //
// ./src/util/constants.js